var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecureYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "-3 -12 30 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1563 8.10938C8.40353 8.10938 6.16406 10.3488 6.16406 13.1014C6.16406 15.8543 8.40353 18.0937 11.1563 18.0937C13.9089 18.0937 16.1484 15.8543 16.1484 13.1014C16.1484 10.3488 13.9089 8.10938 11.1563 8.10938ZM14.1202 12.1613L10.5438 15.7377C10.3937 15.8878 10.1968 15.963 10.0001 15.963C9.80342 15.963 9.60672 15.888 9.45659 15.7377L8.08989 14.371C7.78964 14.071 7.78964 13.5842 8.08989 13.284C8.38994 12.9837 8.87669 12.9837 9.17694 13.284L10.0001 14.1071L13.0332 11.0743C13.3332 10.774 13.82 10.774 14.1202 11.0743C14.4205 11.3743 14.4205 11.8611 14.1202 12.1613Z",
    fill: "url(#paint0_linear_740_78844)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2857 7.10905L22.2849 7.08866C22.2735 6.83699 22.2659 6.57072 22.2613 6.27447C22.2399 4.8298 21.0915 3.63481 19.6466 3.55405C16.6342 3.38593 14.3037 2.40363 12.3126 0.462816L12.2956 0.446624C11.6461 -0.148875 10.6664 -0.148875 10.0167 0.446624L9.99973 0.462816C8.00853 2.40363 5.67811 3.38593 2.66564 3.55425C1.22097 3.63481 0.072354 4.8298 0.0509649 6.27467C0.0465671 6.56892 0.038771 6.83519 0.0273768 7.08866L0.0261774 7.13604C-0.0323929 10.2079 -0.105156 14.0309 1.1738 17.501C1.87704 19.4092 2.9421 21.068 4.33919 22.4315C5.93039 23.9843 8.01453 25.2171 10.5337 26.0954C10.6156 26.124 10.7008 26.1472 10.7875 26.1646C10.9099 26.189 11.033 26.2012 11.1561 26.2012C11.2793 26.2012 11.4026 26.189 11.5248 26.1646C11.6115 26.1472 11.6973 26.1238 11.7796 26.095C14.2958 25.2151 16.3777 23.9817 17.9675 22.4291C19.364 21.0652 20.429 19.406 21.1329 17.4974C22.4166 14.0169 22.3441 10.1867 22.2857 7.10905ZM11.1557 19.6307C7.55516 19.6307 4.62605 16.7016 4.62605 13.101C4.62605 9.50044 7.55516 6.57132 11.1557 6.57132C14.7561 6.57132 17.6854 9.50044 17.6854 13.101C17.6854 16.7016 14.7561 19.6307 11.1557 19.6307Z",
    fill: "url(#paint1_linear_740_78844)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_78844",
    x1: 8.47412,
    y1: 13.7544,
    x2: 16.0767,
    y2: 13.7526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_740_78844",
    x1: 5.16221,
    y1: 14.8139,
    x2: 22.1514,
    y2: 14.8104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureYellow);
export default __webpack_public_path__ + "static/media/secure-yellow.9d376909efaaee813df80c5600864a80.svg";
export { ForwardRef as ReactComponent };